<template>
  <f7-app :params="f7params" >
    <!-- Views/Tabs container -->
      <!-- Your main view/tab, should have "view-main" class. It also has "tab-active" class -->
      <f7-view id="view-other_home" name="other_home" tab url="/"></f7-view>
  
     <!--  <f7-view id="view-how_to_use" name="how_to_use" tab url="/how_to_use/"></f7-view>
      <f7-view id="view-notice" name="notice" tab url="/notice/"></f7-view>
      <f7-view id="view-faq_list" name="faq_list" tab url="/faq_list/"></f7-view>
      <f7-view id="view-terms" name="terms" tab url="/terms/"></f7-view>
      <f7-view id="view-privacypolicy" name="privacypolicy" tab url="/privacypolicy/"></f7-view>
   -->
  </f7-app>
  </template>
  <script>  
    import routes from '../js/routes_other.js';
    import i18n from '@/i18n'
    
    export default {
      i18n,
      data() {
        return {
          // Framework7 Parameters
          f7params: {
            name: 'PointBuy', // App name
            theme: 'auto', // Automatic theme detection
            // App root data
            data: function () {
              return {
                noFirst:false,
                phase1:true,
                phase2:false,
                error_view_code:null,
                arrow_status:'same',
                attention:{
                  visible:false,
                },
                Survey:{
                  visible:false,
                  current_answer:null,
                  answers:{
                    A:'スタンダードコース',
                    B:'チャレンジコース'
                  }
                },
                course:{
                  current:0,
                  info:[
                    {
                      name_en:'challenge',
                      name:'チャレンジコース',
                      history: [
                        [Date.UTC(2019,  1, 10),    0],
                        [Date.UTC(2019,  1, 20), 2000],
                        [Date.UTC(2019,  1, 30), 2024],
                        [Date.UTC(2019,  2, 10), 2128],
                        [Date.UTC(2019,  2, 20), 2025],
                        [Date.UTC(2019,  2, 28), 2127],
                        [Date.UTC(2019,  3, 10), 2025],
                        [Date.UTC(2019,  3, 20), 2122],
                        [Date.UTC(2019,  3, 30), 2152],
                        [Date.UTC(2019,  4, 10), 2124],
                        [Date.UTC(2019,  4, 20), 2135],
                        [Date.UTC(2019,  4, 30), 2236],
                        [Date.UTC(2019,  5, 10), 2138],
                        [Date.UTC(2019,  5, 20), 2236],
                        [Date.UTC(2019,  5, 30), 2138],
                        [Date.UTC(2019,  6, 10), 2336],
                        [Date.UTC(2019,  6, 20), 2236],
                        [Date.UTC(2019,  6, 30), 2337],
                        [Date.UTC(2019,  7, 10), 2232],
                        [Date.UTC(2019,  7, 20), 2331],
                        [Date.UTC(2019,  7, 30), 2235],
                        [Date.UTC(2019,  8, 10), 2338],
                        [Date.UTC(2019,  8, 20), 2439],
                        [Date.UTC(2019,  8, 30), 2234],
                        [Date.UTC(2019,  9, 10), 2437],
                        [Date.UTC(2019,  9, 20), 2245],
                        [Date.UTC(2019,  9, 30), 2446],
                        [Date.UTC(2019, 10, 10), 2524],
                        [Date.UTC(2019, 10, 20), 2444],
                        [Date.UTC(2019, 10, 30), 2243],
                        [Date.UTC(2019, 11, 10), 2348],
                        [Date.UTC(2019, 11, 20), 2247],
                        [Date.UTC(2019, 11, 30), 2344],
                        [Date.UTC(2019, 12, 10), 2246],
                        [Date.UTC(2019, 12, 20), 2337],
                        [Date.UTC(2019, 12, 30), 2239],
                        [Date.UTC(2020,  1, 10), 2331],
                        [Date.UTC(2020,  1, 20), 2432],
                        [Date.UTC(2020,  1, 30), 2500]
                      ]
                    },
                    {
                      name_en:'standard',
                      name:'スタンダードコース',
                      history: [
                        [Date.UTC(2019,  1, 10),    0],
                        [Date.UTC(2019,  1, 20), 2000],
                        [Date.UTC(2019,  1, 30), 2024],
                        [Date.UTC(2019,  2, 10), 2128],
                        [Date.UTC(2019,  2, 20), 2025],
                        [Date.UTC(2019,  2, 28), 2127],
                        [Date.UTC(2019,  3, 10), 2025],
                        [Date.UTC(2019,  3, 20), 2122],
                        [Date.UTC(2019,  3, 30), 2152],
                        [Date.UTC(2019,  4, 10), 2124],
                        [Date.UTC(2019,  4, 20), 2135],
                        [Date.UTC(2019,  4, 30), 2236],
                        [Date.UTC(2019,  5, 10), 2138],
                        [Date.UTC(2019,  5, 20), 2236],
                        [Date.UTC(2019,  5, 30), 2138],
                        [Date.UTC(2019,  6, 10), 2336],
                        [Date.UTC(2019,  6, 20), 2236],
                        [Date.UTC(2019,  6, 30), 2337],
                        [Date.UTC(2019,  7, 10), 2232],
                        [Date.UTC(2019,  7, 20), 2331],
                        [Date.UTC(2019,  7, 30), 2235],
                        [Date.UTC(2019,  8, 10), 2338],
                        [Date.UTC(2019,  8, 20), 2439],
                        [Date.UTC(2019,  8, 30), 2234],
                        [Date.UTC(2019,  9, 10), 2437],
                        [Date.UTC(2019,  9, 20), 2245],
                        [Date.UTC(2019,  9, 30), 2446],
                        [Date.UTC(2019, 10, 10), 2524],
                        [Date.UTC(2019, 10, 20), 3444],
                        [Date.UTC(2019, 10, 30), 3243],
                        [Date.UTC(2019, 11, 10), 3348],
                        [Date.UTC(2019, 11, 20), 3247],
                        [Date.UTC(2019, 11, 30), 3344],
                        [Date.UTC(2019, 12, 10), 3246],
                        [Date.UTC(2019, 12, 20), 3337],
                        [Date.UTC(2019, 12, 30), 3439],
                        [Date.UTC(2020,  1, 10), 3331],
                        [Date.UTC(2020,  1, 20), 3232],
                        [Date.UTC(2020,  1, 30), 3000]
                      ]
                    }
                  ]
                },
                user: {
                  firstName: 'Johson',
                  lastName: 'Doe',
                },
                // Demo products for Catalog section
                products: [
                  {
                    id: '1',
                    title: 'Apple iPhone 8',
                    description: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Nisi tempora similique reiciendis, error nesciunt vero, blanditiis pariatur dolor, minima sed sapiente rerum.'
                  },
                  {
                    id: '2',
                    title: 'Apple iPhone 8 Plus',
                    description: 'Velit odit autem modi saepe ratione totam minus, aperiam, labore quia provident temporibus quasi est ut aliquid blanditiis beatae suscipit odio vel! '
                  },
                  {
                    id: '3',
                    title: 'Apple iPhone X',
                    description: 'Expedita sequi perferendis quod illum pariatur aliquam, alias laboriosam! Vero blanditiis placeat, mollitia necessitatibus reprehenderit. '
                  },
                ]
              };
            },
  
            // App routes
            routes: routes,
            view: {
              pushState: false,
            },
            sheet: {
              backdrop: true,  // Enables Sheet backdrop (dark semi transparent layer behind)
            }
          },
          // Login screen data
          username: '',
          password: '',
  
          iniData: this.ini(null,true),
          errData: null,
        }
      },
      methods: {
        // 全局: 打开页面时初始化
        ini(opt, rtn){
          opt = ES.extend(opt, {
            wait: false, // 是否显示等待(转圈)
            sessBack: null, // sess自动延期的回调
          });
          if(rtn) return opt;
          else this.iniData = opt;
        },
      },
      mounted() {
      },
    };
  </script>
  